import { useMemo } from 'react';
import { useTable, useSortBy, useFilters, usePagination } from 'react-table';
import config from '../config';

function defaultColumnFilter({ column: { filterValue, setFilter } }) {
  return (
    <input
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      placeholder={`Search`}
    />
  );
}

function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id }
}) {
  const options = useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      const value = row.values[id];
      if (value) {
        options.add(value);
      }
    });
    return [...options.values()];
  }, [id, preFilteredRows]);
  return (
    <select
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value.split(','));
      }}
      className='filter-dropdown'
    >
      <option value=''>All</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
      {config.finderMultiSelect[id]
        ? Object.keys(config.finderMultiSelect[id]).map((option, i) => (
            <option key={i} value={config.finderMultiSelect[id][option]}>
              {option}
            </option>
          ))
        : ''}
    </select>
  );
}

function multiSelectFilter(rows, columnIds, filterValue) {
  return filterValue[0] === ''
    ? rows
    : rows.filter((row) => filterValue.includes(row.original[columnIds]));
}

const columnInfo = [
  {
    Header: 'System ID',
    accessor: 'System ID',
    Cell: (e) => <a href={'/edit/' + e.value}>{e.value}</a>
  },
  {
    Header: 'System Name',
    accessor: 'System Name'
  },
  {
    Header: 'Priority',
    accessor: 'Priority',
    Cell: (e) => <>{e.value === -9999 ? '' : e.value}</>
  },
  {
    Header: 'Assignee',
    accessor: 'Assignee',
    Filter: SelectColumnFilter
  },
  {
    Header: 'Streamlined',
    accessor: 'isStreamline',
    Filter: SelectColumnFilter
  },
  {
    Header: 'Status',
    accessor: 'Status',
    Filter: SelectColumnFilter
  },
  {
    Header: 'Detailed Status',
    accessor: 'Detailed Status',
    filter: multiSelectFilter,
    Filter: SelectColumnFilter
  },
  {
    Header: 'Contact',
    accessor: 'Contact'
  },
  {
    Header: 'System Type',
    accessor: 'System Type'
  },
  {
    Header: 'FEMA Accreditation',
    accessor: 'FEMA Accreditation'
  },
  {
    Header: 'Counties',
    accessor: 'Counties'
  },
  {
    Header: 'States',
    accessor: 'States'
  },
  {
    Header: 'NLD System Summary',
    accessor: 'NLD System Summary',
    disableFilters: true,
    disableSortBy: true,

    Cell: (e) => (
      <a href={e.value} target='_blank' rel='noreferrer'>
        Link
      </a>
    )
  },
  {
    Header: 'BucketView Data Directory',
    accessor: 'BucketView Data Directory',
    disableFilters: true,
    disableSortBy: true,

    Cell: (e) => (
      <a href={e.value} target='_blank' rel='noreferrer'>
        Link
      </a>
    )
  }
];

export default function useSystemsFilter(systemsMetadata) {
  const defaultColumn = useMemo(
    () => ({
      Filter: defaultColumnFilter
    }),
    []
  );
  const data = useMemo(() => systemsMetadata, [systemsMetadata]);

  const columns = useMemo(() => columnInfo, []);
  return useTable(
    {
      columns,
      data,
      defaultColumn,
      initialState: { pageSize: config.pageSize }
    },
    useFilters,
    useSortBy,

    usePagination
  );
}
